/**
 * Support access: every restaurant whose owner has let support in now,
 * soonest to run out first, with what they asked to be looked at. A session
 * is opened from the restaurant's own page.
 */

import { Link } from 'react-router-dom';
import { displayLocale, usePlatformSupportGrants } from '@restaurant/api-client';
import { Card, Empty, ErrorNotice, Loading } from '@restaurant/ui';

import { formatMoment } from '../words';

export function SupportPage() {
  const grants = usePlatformSupportGrants();
  const locale = displayLocale();

  return (
    <>
      <header className="pf__head">
        <div>
          <h1 className="pf__title">Support access</h1>
          <p className="pf__sub">
            Restaurants whose owners have let support into their back office now. Open one to
            start a session; the owners are told, and it is on both logs.
          </p>
        </div>
      </header>

      <Card>
        {grants.isPending && <Loading label="Loading" />}
        {grants.isError && <ErrorNotice message={grants.error.message} />}
        {grants.data && grants.data.length === 0 && (
          <Empty
            title="No restaurant has let support in"
            description="An owner turns it on in their back office, under Settings → Support access."
          />
        )}
        {grants.data && grants.data.length > 0 && (
          <div className="pf__table-wrap">
            <table className="pf__table">
              <thead>
                <tr>
                  <th>Restaurant</th>
                  <th>Until</th>
                  <th>May</th>
                  <th>Their note</th>
                </tr>
              </thead>
              <tbody>
                {grants.data.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <Link className="pf__rowlink" to={`/restaurants/${row.restaurant_id}`}>
                        {row.restaurant_name}
                      </Link>{' '}
                      <span className="pf__mono pf__faint">{row.restaurant_slug}</span>
                    </td>
                    <td className="pf__nowrap">{formatMoment(row.expires_at, locale)}</td>
                    <td>{row.allow_changes ? 'Look and change' : 'Look only'}</td>
                    <td>{row.note || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
